import CryptoJS from "crypto-js";

const clientId = 'jkteexupyxjkqt5qsham';
const secret = '1dfc9d588af3403196cc0286c7429707';

function encrypt_AES_128(data, secretKey) {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const encrypted = CryptoJS.AES.encrypt(data, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

function decrypt_AES_128(data, secretKey=secret) {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
    const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
}

function getTime(){
    var timestamp = new Date().getTime();
    return timestamp;
}

// Token verification calculation
function calcSign(clientId,timestamp,nonce,signStr,secret){
    var str = clientId + timestamp + nonce + signStr;
    var hash = CryptoJS.HmacSHA256(str, secret);
    var hashInBase64 = hash.toString();
    var signUp = hashInBase64.toUpperCase();
    return signUp;
}

// Business verification calculation
function calcBusinessSign(clientId,accessToken,timestamp,nonce,signStr,secret){
    var str = clientId + accessToken +timestamp + nonce + signStr;
    var hash = CryptoJS.HmacSHA256(str, secret);
    var hashInBase64 = hash.toString();
    var signUp = hashInBase64.toUpperCase();
    return signUp;
}

// Generate signature string
function stringToSign(url, mode, method, secret, bodyStr=""){
    var sha256 = "";
    var headersStr = ""
    var map = {}
    
    sha256 = CryptoJS.SHA256(bodyStr)

    map["signUrl"] = method + "\n" + sha256 + "\n" + headersStr + "\n" + url
    map["url"] = url
    return map
}



function calculateHeaders(headerType, url, accessToken, method, bodyStr) {
    var timestamp = getTime();

    // const httpMethod = pm.request.method.toUpperCase();
    // const query = pm.request.url.query;
    // const mode = pm.request.body.mode;
    // const headers = pm.request.headers;
    
    // sha256
    var signMap = stringToSign(url, "cors", method, secret, bodyStr)
    // var urlStr = signMap["url"]
    var signStr = signMap["signUrl"]
    var nonce = ""
    var sign = headerType === 'token' ? calcSign(clientId, timestamp, nonce, signStr, secret) : calcBusinessSign(clientId, accessToken, timestamp,nonce,signStr, secret);

    return { easy_sign: sign, nonce: nonce, t: timestamp,  clientId: clientId, accessToken: accessToken, stringToSign: stringToSign}
}

export { encrypt_AES_128, decrypt_AES_128 , getTime, calcSign, calcBusinessSign, calculateHeaders}